import { render } from "./ServiceDetailSheet.vue?vue&type=template&id=1889d06c&scoped=true"
import script from "./ServiceDetailSheet.vue?vue&type=script&lang=js"
export * from "./ServiceDetailSheet.vue?vue&type=script&lang=js"

import "./ServiceDetailSheet.vue?vue&type=style&index=0&id=1889d06c&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1889d06c"]])

export default __exports__